'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _feedItemAttachment = require('../feed-item-attachment');

var _feedItemAttachment2 = _interopRequireDefault(_feedItemAttachment);

var _feedItemContainer = require('../feed-item-container');

var _feedItemContainer2 = _interopRequireDefault(_feedItemContainer);

var _Uniform = require('../../Uniform');

require('./message-feed-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var maxMessageLength = 500;

var MessageFeedItem = function (_PureComponent) {
  _inherits(MessageFeedItem, _PureComponent);

  function MessageFeedItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MessageFeedItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageFeedItem.__proto__ || Object.getPrototypeOf(MessageFeedItem)).call.apply(_ref, [this].concat(args))), _this), _this.showFullText = function () {
      _this.setState({
        showFullText: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MessageFeedItem, [{
    key: 'truncateMessage',
    value: function truncateMessage(message) {
      if (!message) return message;

      return message.length > maxMessageLength ? message.substring(0, maxMessageLength).trim() : message;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var item = this.props.content.item;
      var message = void 0;
      var messageStart = void 0;
      var messageEnd = void 0;
      if (item.message) {
        // the maximum characters in a message before it's truncated
        // get rid of extra whitespace so it doesn't throw off the count
        // trim after truncating to so there's no possibility for space between the ellipsis and words
        message = item.message.trim();
        messageStart = this.truncateMessage(message);
        // if the original message is the same length as the truncated message, nothing was truncated.
        // so, because the full message fits within the character limit, set the latter half of the
        // message to empty string
        messageEnd = message.length === messageStart.length ? '' : message.substring(messageStart.length);
      }

      return _react2.default.createElement(
        _feedItemContainer2.default,
        _extends({ className: 'message hudl-message',
          date: this.props.content.dateCreated,
          title: item.title
        }, this.props),
        _react2.default.createElement(
          'div',
          { className: 'feedattachments' },
          _react2.default.createElement(
            'div',
            { className: 'feedattachments-wrapper' },
            _react2.default.createElement('div', { className: 'content' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-description' },
            _react2.default.createElement(
              _Uniform.Subhead,
              { className: 'subject' },
              item.subject
            ),
            message && message.length ? _react2.default.createElement(
              _Uniform.Text,
              { className: 'uni-margin--half--top full-text-root' },
              _react2.default.createElement(
                'span',
                { className: 'message' },
                messageStart
              ),
              messageEnd && messageEnd.length ? _react2.default.createElement(
                'span',
                null,
                this.state.showFullText ? _react2.default.createElement(
                  'span',
                  { className: 'full-text' },
                  messageEnd
                ) : _react2.default.createElement(
                  'span',
                  { className: 'show-full-text', onClick: this.showFullText },
                  '...',
                  _react2.default.createElement(
                    'a',
                    { className: 'show-full-text' },
                    'Show More'
                  )
                )
              ) : null
            ) : null,
            item.attachments && item.attachments.length ? _react2.default.createElement(
              'div',
              { className: 'message-attachments' },
              _react2.default.createElement(
                'ul',
                null,
                item.attachments.map(function (attachment) {
                  _react2.default.createElement(_feedItemAttachment2.default, _extends({}, attachment, { onAttachmentClick: _this2.props.onAttachmentClick }));
                })
              )
            ) : null
          )
        )
      );
    }
  }]);

  return MessageFeedItem;
}(_react.PureComponent);

MessageFeedItem.propTypes = {
  author: _react.PropTypes.object.isRequired,
  content: _react.PropTypes.shape({
    dateCreated: _react.PropTypes.string.isRequired,
    item: _react.PropTypes.shape({
      attachments: _react.PropTypes.arrayOf(_react.PropTypes.shape({
        attachmentId: _react.PropTypes.string.isRequired,
        fileName: _react.PropTypes.string.isRequired
      })),
      message: _react.PropTypes.string.isRequired,
      subject: _react.PropTypes.string.isRequired,
      title: _react.PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  onAttachmentClick: _react.PropTypes.func.isRequired
};
exports.default = MessageFeedItem;